﻿$.fn.dxCtrlGridEntete = function custom_dxCtrlGridEntete(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlgridentete dx-ctrl");
        this.createInstance(new cdxCtrlGridEntete(this, option));
    }
    return this;
}

window.cdxCtrlGridEntete = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid] == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid] = {}
    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].config_grid_anim == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].config_grid_anim = {}

    var dx = null;
    var firstLoad = true
    var $DivSearch = null
    function mConstruit() {
        container.empty();

        dx = $("<div class='dxgridpopsoft'/>").appendTo(container).dxDataGrid({
            dataSource: [],
            columns: option.columns,
            allowColumnReordering: option.allowColumnReordering,
            allowColumnResizing: option.allowColumnResizing,
            showColumnHeaders: ((typeof option.showColumnHeaders == "undefined") ? true : option.showColumnHeaders),
            loadPanel: { enabled: false },
            sorting: {
                mode: "multiple"
            },
            columnChooser: {
                enabled: option.allow_columnchooser
            },
            groupPanel: { visible: ((typeof option.allowGroup == 'undefined') ? true : option.allowGroup) },
            toolbar: {
                items: mGetItemsToolbar()
            },
            //onToolbarPreparing: function () { debugger; },
            stateStoring: {
                enabled: true,
                type: "custom",
                storageKey: "exe",
                savingTimeout: 100,
                customLoad: function () {
                    if (typeof option.bddCtrl.utiCourantParaJson[option.context_grid].config_grid_anim.state == 'undefined') option.bddCtrl.utiCourantParaJson[option.context_grid].config_grid_anim.state = null
                    return option.bddCtrl.utiCourantParaJson[option.context_grid].config_grid_anim.state
                },
                customSave: function (state) {
                    if (txtSearchLucene != null && txtSearchLucene.length > 0) return //on ne sauvegarde pas l'état quand on et en recherche
                    option.bddCtrl.utiCourantParaJson[option.context_grid].config_grid_anim.state = state
                    option.bddCtrl.mSaveParaJsonUtilisateur();
                    onStateChanged(state)
                }
            },
            onToolbarPreparing: option.onToolbarPreparing,
            onContentReady: function (e) {
                dx = e.component

                //e.component.element().find(".dx-toolbar-items-container").css("height", "48px")

                e.component.element().find(".dx-datagrid-group-panel").css("font-family", "barlow condensed")
                e.component.element().find(".dx-datagrid-header-panel").css("padding", "0 5px")
                e.component.element().find(".dx-datagrid-rowsview").css("display", "none")
                e.component.element().find(".dx-datagrid-headers").css("background-color", theme.backgroundcolorSelect)
                window.setTimeout(function () { e.component.element().find(".dx-datagrid-group-panel").css("font-family", "barlow condensed") }, 200)
                //e.component.element().find(".dx-datagrid").children().each(function () {
                //    if (!$(this).hasClass("dx-datagrid-headers") && !$(this).hasClass("dx-datagrid-header-panel")) {
                //        $(this).css("display", "none")
                //    }
                //});
                if (firstLoad && typeof option.onFirstContentReady != 'undefined') {
                    option.onFirstContentReady(e)
                    lstFieldGrpSort = Me.mGetLstFieldGrpSort()
                }
                firstLoad = false
            }
        }).dxDataGrid("instance")
        $DivSearch = $("<div style='display:none;text-align:center;padding:10px 5px 5px 5px;border-botttom:" + theme.border + ";height:36px;background-color:" + theme.backgroundcolorTooltip + ";'/>").appendTo(container)

        if (txtSearchLucene.length > 0) Me.mChangeSearchLucene(txtSearchLucene)
    }

    this.mReinitState = function () { dx.state(null); }

    var StateBeforeSearchLucene = null
    var txtSearchLucene = ""
    this.mChangeSearchLucene = function (txtSearch, dxCtrlRecherche) {
        txtSearchLucene = txtSearch
        if (txtSearchLucene != null && txtSearchLucene.length > 0) {
            //on cache
            //cache le panel groupe
            dx.element().find(".dx-datagrid-group-panel").parent().parent().css("display", "none")
            //récupère le state
            if (StateBeforeSearchLucene == null) {
                StateBeforeSearchLucene = dx.state()
                dx.clearGrouping()
                dx.clearSorting()
                dx.option({
                    showColumnHeaders: false
                })
            }
            onStateChanged(dx.state)
            var txtSearchReduit = txtSearch.reduit(15)
            $DivSearch.html("<span style='opacity:0.2;'>Recherche sur </span><i><b title='" + txtSearch + "'>" + txtSearchReduit + "</b>&nbsp;</i>")
            var $A = $("<a href='javascript:void(0)'>Trié par pertinence</a>").appendTo($DivSearch)
            if (option.bddCtrl.utiCourantParaJson[option.context_grid].order_search == "score") {
                $A.text("Trié par pertinence")
                $A.attr("title", "Cliquer pour trier par date décroissante")
            } else {
                $A.text("Trié par date décroissante")
                $A.attr("title", "Cliquer pour trier par pertinence")
            }
            $A.on("click", function () {
                if (option.bddCtrl.utiCourantParaJson[option.context_grid].order_search == "score") {
                    option.bddCtrl.utiCourantParaJson[option.context_grid].order_search = "date"
                    $A.text("Trié par date décroissante")
                    //mRemoveMinimalTips($A)
                    $A.attr("title", "Cliquer pour trier par pertinence")
                } else {
                    option.bddCtrl.utiCourantParaJson[option.context_grid].order_search = "score"
                    $A.text("Trié par pertinence")
                    //mRemoveMinimalTips($A)
                    $A.attr("title", "Cliquer pour trier par date décroissante")
                }
                option.bddCtrl.mSaveParaJsonUtilisateur();
                option.onDemandeReloadData()
            })

            if (typeof dxCtrlRecherche != 'undefined' && dxCtrlRecherche != null) {
                var $I = $("<i class='fas fa-xmark state-hover dx-theme-accent-as-text-color' style='padding:5px;border-radius:50%;'></i>").appendTo($DivSearch)
                $I.on("click", function () {
                    dxCtrlRecherche.option("value", "")
                })
            }

            $DivSearch.show()
        } else {
            //on affiche
            //affiche le panel groupe
            dx.element().find(".dx-datagrid-group-panel").parent().parent().css("display", "")
            if (typeof option.showColumnHeaders == 'undefined' || option.showColumnHeaders) dx.option({
                showColumnHeaders: true
            })
            dx.state(StateBeforeSearchLucene)
            option.bddCtrl.utiCourantParaJson[option.context_grid].config_grid_anim.state = StateBeforeSearchLucene
            option.bddCtrl.mSaveParaJsonUtilisateur();
            onStateChanged(StateBeforeSearchLucene)
            StateBeforeSearchLucene = null
            $DivSearch.hide()
        }
    }

    //var dxChkSelect = null
    //var $DivNbre = null
    function mGetItemsToolbar() {
        var items = []
        items.push("groupPanel")
        if (option.allow_columnchooser) items.push("columnChooserButton")
        return items
    }

    var lstFieldGrpSort = []
    function onStateChanged(newState) {
        var newLstFieldGrpSort = Me.mGetLstFieldGrpSort()
        if (JSON.stringify(lstFieldGrpSort) != JSON.stringify(newLstFieldGrpSort)) {
            lstFieldGrpSort = newLstFieldGrpSort
            if (typeof option.onGroupSortChanged != 'undefined') option.onGroupSortChanged(newState, lstFieldGrpSort)
        } else {
            if (typeof option.onStateChanged != 'undefined') option.onStateChanged(newState)
        }
    }

    this.mGetLstFieldGrpSort = function () {
        var lst = []
        for (var i = 0; i < dx.option("columns").length; i++) {
            lst.push(dx.columnOption(i))
        }
        var newLstFieldGrpSort = []
        var sortIndex = 0
        lst.filter(function (col) { return typeof col.groupIndex != 'undefined' }).sort(function (o1, o2) { return o1.groupIndex - o2.groupIndex }).forEach(function (col) {
            delete col.sortIndex
            var field = option.fields.filter(function (field) { return col.dataField == field.dataField })[0]
            newLstFieldGrpSort.push({
                field: field,
                groupIndex: col.groupIndex,
                sortOrder: ((typeof col.sortOrder == 'undefined') ? "asc" : col.sortOrder)
            })
            if (typeof field.filterLinkGrp != 'undefined') {
                var field2 = option.fields.filter(function (field2) { return field.filterLinkGrp == field2.dataField })[0]
                newLstFieldGrpSort.push({
                    field: field2,
                    sortIndex: sortIndex,
                    sortOrder: ((typeof col.sortOrder == 'undefined') ? "asc" : col.sortOrder)
                })
                sortIndex += 1
            }
        })
        lst.filter(function (col) { return typeof col.sortIndex != 'undefined' }).sort(function (o1, o2) { return o1.sortIndex - o2.sortIndex }).forEach(function (col) {
            var field = option.fields.filter(function (field) { return col.dataField == field.dataField })[0]
            var fieldGrpSort = newLstFieldGrpSort.filter(function (o) { return o.field.dataField == col.dataField })[0]
            //if (typeof fieldGrpSort == 'undefined') {
            newLstFieldGrpSort.push({
                field: field,
                sortIndex: sortIndex,
                sortOrder: ((typeof col.sortOrder == 'undefined') ? "asc" : col.sortOrder)
            })
            sortIndex += 1
            //} else {
            //    fieldGrpSort.sortOrder = ((typeof col.sortOrder == 'undefined') ? "asc" : col.sortOrder)
            //}

        })
        return newLstFieldGrpSort
    }

    this.mGetToolbar = function () {
        try {
            return $(dx.element().find(".dx-toolbar")[0]).dxToolbar("instance")
        } catch (e) {
        }
    }

    this.component = function () { return dx; }
    this.element = function () { return container; }

    mConstruit();
}